var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5828_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.024 0C18.84 0 24 5.58838 24 11.982C24 19.3971 17.952 24 12 24C10.032 24 7.848 23.4712 6.096 22.4377C5.484 22.0651 4.968 21.7887 4.308 22.005L1.884 22.7261C1.272 22.9184 0.72 22.4377 0.9 21.7887L1.704 19.0966C1.836 18.7241 1.812 18.3275 1.62 18.015C0.588 16.1162 0 14.0371 0 12.018C0 5.69654 5.052 0 12.024 0ZM17.508 10.4917C16.656 10.4917 15.972 11.1768 15.972 12.03C15.972 12.8713 16.656 13.5684 17.508 13.5684C18.36 13.5684 19.044 12.8713 19.044 12.03C19.044 11.1768 18.36 10.4917 17.508 10.4917ZM11.976 10.4917C11.136 10.4797 10.44 11.1768 10.44 12.018C10.44 12.8713 11.124 13.5563 11.976 13.5684C12.828 13.5684 13.512 12.8713 13.512 12.03C13.512 11.1768 12.828 10.4917 11.976 10.4917ZM6.444 10.4917C5.592 10.4917 4.908 11.1768 4.908 12.03C4.908 12.8713 5.604 13.5684 6.444 13.5684C7.296 13.5563 7.98 12.8713 7.98 12.03C7.98 11.1768 7.296 10.4917 6.444 10.4917Z",
    fill: "#0085FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5828_40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifIcon);
export default __webpack_public_path__ + "static/media/notif-icon.9ac4855d396482266beede4f0f043f9e.svg";
export { ForwardRef as ReactComponent };